import type { JSX } from 'react';
import type { EnvironmentValue } from '@majuscule/contracts';
import { Badge } from '@/components/ui/badge';

export const ENVIRONMENT_LABELS: Record<EnvironmentValue, string> = {
  production: 'Production',
  staging: 'Staging',
};

/** Environment of a key or user: staging is never billed (D-ENV.1). */
export function EnvironmentBadge({ environment }: { environment: EnvironmentValue }): JSX.Element {
  return environment === 'staging' ? (
    <Badge variant="warning" title="Non facturée au client">
      Staging
    </Badge>
  ) : (
    <Badge variant="info">Production</Badge>
  );
}
